import request from '@/utils/request'

const url = '/home/scenes/'
const api = {
  getScenes (data) {
    return request({
      url: url + 'getScenes',
      method: 'post',
      data
    })
  },
  getGroupList (data) {
    return request({
      url: url + 'getGroupList',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/scenes.js